import React from 'react';
const typeComponentMap = {
    string: require('./StringCell').default,
    custom: require('./CustomCell').default,
    date: require('./DateCell').default,
    field: require('./FieldCell').default,
};
const ChangelogCell = (props) => {
    const { field, cellType = 'string', data, metadata, timeZone } = props;
    const ComponentToRender = typeComponentMap[cellType];
    return (data[field] != undefined ?
        React.createElement(ComponentToRender, { value: data[field], data: data, metadata: metadata, field: field, timeZone: timeZone }) : null);
};
export default ChangelogCell;
//# sourceMappingURL=ChangelogCell.js.map